import { useMemo } from 'react';
import { RouteObject } from 'react-router-dom';

import { useMfsRoutes } from './useMfsRoutes';
import { buildAppRoutes } from './buildAppRoutes';

export function useAppRoutes() {
  const mfsRoutes = useMfsRoutes();

  return useMemo(() => {
    if (!mfsRoutes) {
      return;
    }

    const authRoutes = [] as RouteObject[];
    const publicRoutes = [] as RouteObject[];

    mfsRoutes.forEach(
      (route) => {
        if (route.path && route.path.startsWith('my/')) {
          const clonedRoute: RouteObject = {
            ...route,
            path: route.path.substring('my/'.length),
          };
          authRoutes.push(clonedRoute);
        } else {
          publicRoutes.push(route);
        }
      },
      [mfsRoutes]
    );

    return buildAppRoutes(authRoutes, publicRoutes);
  }, [mfsRoutes]);
}
